import { render } from "./tips.vue?vue&type=template&id=1d180f8c&scoped=true"
import script from "./tips.vue?vue&type=script&lang=js"
export * from "./tips.vue?vue&type=script&lang=js"

import "./tips.vue?vue&type=style&index=0&id=1d180f8c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d180f8c"]])

export default __exports__